import React, { useEffect, useMemo, useState } from 'react';
import Loading from '../Common/Loading/Loading';
import api from '../../middleware/api';
import useFetchData from '../../hooks/useFetchData';
import LoadingSpinner from '../Common/Loading/LoadingSpinner';
import { useNavigate } from 'react-router-dom';
import { ShoppingCartIcon, PlusCircleIcon } from '@heroicons/react/24/outline';
import { formatDateOnly } from '../../utils/dateFormatter';

const Selections = () => {
    const navigate = useNavigate();
    const { data, error, isLoading } = useFetchData('/selections');
    const [searchValue, setSearchValue] = useState('');
    const [selections, setSelections] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    useEffect(() => {
        if (data) {
            setSelections(prevSelections => [...prevSelections, ...data]);
        }
    }, [data]);

    const loadMoreSelections = async () => {
        setIsLoadingMore(true);
        const offset = (currentPage + 1) * 100;
        try {
            const response = await api.get(`/selections?cursor=${offset}`);
            console.log(response.data)
            if (response.data && response.data.data) {
                setSelections(prevSelections => [...prevSelections, ...response.data.data]);
                setCurrentPage(prevPage => prevPage + 1);
            }
        } catch (err) {
            console.error('Failed to load more selections:', err);
        } finally {
            setIsLoadingMore(false);
        }
    };

    const sortedData = useMemo(() => {
        if (searchValue) return selections.filter(selection => selection._id.includes(searchValue));

        if (selections.length > 0) {
            return selections.sort((a, b) => {
                return new Date(b['Created Date']) - new Date(a['Created Date']);
            });
        }
        return selections;
    }, [selections, searchValue]);

    const handleSearchValue = (e) => {
        setSearchValue(e.target.value);
    };

    const goToSelection = (id) => {
        return window.open(`/selections/${id}`, '_blank');
    };
    
    const handleCreateNewOrder = () => {
        navigate('/commander-selection', { state: { selectedMixtures: [] } });
    };

    const formatDate = (date) => {
        return formatDateOnly(date);
    };

    if (error) return <div className="text-red-500">Une erreur est survenue : {error.message}</div>;
    return (
        <div className="p-4">
            <div className="flex justify-between items-center mb-4">
                <h1 className="text-2xl font-bold">Selections</h1>
                <button 
                    onClick={handleCreateNewOrder}
                    className="btn btn-primary flex items-center gap-2"
                >
                    <ShoppingCartIcon className="h-5 w-5" />
                    Nouvelle commande
                </button>
            </div>
            
            <input
                onChange={handleSearchValue}
                type="text"
                placeholder="Coller l'ID d'une sélection"
                className="border p-2 mb-4 w-full"
            />
            {isLoading && <LoadingSpinner style="medium" />}
            {!isLoading && selections.length > 0 &&
                (
                    <div className="overflow-x-auto">
                        <div className="flex font-bold bg-gray-200 p-2">
                            <p className="flex-1">Nom</p>
                            <p className="flex-1">Prénom</p>
                            <p className="flex-1">Email</p>
                            <p className="flex-1">Mélanges</p>
                            <p className="flex-1">Crée le</p>
                        </div>
                        {sortedData.length > 0 && sortedData.map((selection, index) => {
                            return (
                                <div
                                    className="flex p-2 border-b hover:bg-gray-100 cursor-pointer"
                                    onClick={() => goToSelection(selection._id)}
                                    key={index}
                                >
                                    <p className="flex-1">{selection.user.firstname}</p>
                                    <p className="flex-1">{selection.user.lastname}</p>
                                    <p className="flex-1">{selection.user.email}</p>
                                    <p className="flex-1">{selection.mixtures.length}</p>
                                    <p className="flex-1">{formatDate(new Date(selection['Created Date']))}</p>
                                </div>
                            );
                        })}
                    </div>
                )
            }
            {!isLoading && selections.length === 0 && <p className="text-center text-gray-500">Aucune sélection ne correspond à votre recherche</p>}
            {data && data.remaining > (currentPage + 1) * 100 && (
                <div className="flex justify-center mt-4">
                    <button
                        onClick={loadMoreSelections}
                        className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 flex items-center"
                        disabled={isLoadingMore}
                    >
                        {isLoadingMore ? <LoadingSpinner style="medium" /> : 'Charger plus'}
                    </button>
                </div>
            )}
        </div>
    );
};

export default Selections;
